/* eslint @typescript-eslint/no-var-requires: "off" */
import jwt_decode from "jwt-decode";
import { EN_ALGO, EN_KEY } from "utilFunctions/Constants/Constants";
let CryptoJS = require("crypto-js");
function handleJWTToken(credential) {
  const decoded_user = jwt_decode(credential);
  const header = {
    alg: "HS256",
    typ: "JWT",
  };
  let data = {
    email: decoded_user.email,
    iat: decoded_user.iat,
  };
  const secret = decoded_user.email;
  const token = createJWT(header, data, secret);
  return token;
}

function createJWT(header, data, secret = undefined) {
  let stringifiedHeader = CryptoJS.enc.Utf8.parse(JSON.stringify(header));
  let encodedHeader = base64url(stringifiedHeader);
  let stringifiedData = CryptoJS.enc.Utf8.parse(JSON.stringify(data));
  let encodedData = base64url(stringifiedData);
  let token = encodedHeader + "." + encodedData;
  if (!secret) return token;
  return encodedHeader + "." + encodedData + ".";
}
function base64url(source) {
  let encodedSource = CryptoJS.enc.Base64.stringify(source);
  encodedSource = encodedSource.replace(/=+$/, "");
  encodedSource = encodedSource.replace(/\+/g, "-");
  encodedSource = encodedSource.replace(/\//g, "_");
  return encodedSource;
}

async function encrypt1(text) {
  const encoder = new TextEncoder();
  const data = encoder.encode(text);

  const iv = window.crypto.getRandomValues(new Uint8Array(12));
  const key = await window.crypto.subtle.importKey(
    "raw",
    hexStringToUint8Array(EN_KEY),
    EN_ALGO,
    false,
    ["encrypt"]
  );

  const ciphertext = await window.crypto.subtle.encrypt(
    { name: EN_ALGO, iv: iv },
    key,
    data
  );

  const encryptedData = new Uint8Array(iv.byteLength + ciphertext.byteLength);
  encryptedData.set(iv, 0);
  encryptedData.set(new Uint8Array(ciphertext), iv.byteLength);

  const encodedEncryptedData = btoa(
    String.fromCharCode(...new Uint8Array(encryptedData))
  );
  return encodedEncryptedData;
}
function hexStringToUint8Array(hexString) {
  const bytes = new Uint8Array(hexString.length / 2);
  for (let i = 0; i < hexString.length; i += 2) {
    bytes[i / 2] = parseInt(hexString.substr(i, 2), 16);
  }
  return bytes;
}

export { handleJWTToken, createJWT, base64url, encrypt1 };
